module.exports = __webpack_public_path__ + "img/ring_r_e_0_1@3x.9ecc8a64.png";